import UserModel from './userModel'

export default class UserTokenModel extends UserModel {
  public accessToken: string = ''
  public refreshToken: string = ''

  constructor(data?: any) {
    super(data)
    if (data) {
      Object.assign(this, data)
    }
  }
}
